import { useHistory } from "react-router-dom";
import NotificationIcon from "src/images/Icons/newIcons/notifications/notification.svg";

import { htmlFormatter } from "../../../formatters/htmlFormatter";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface LocalLinkNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
}

export function LocalLinkNotification({
	notification,
	removeNotification,
}: LocalLinkNotificationProps) {
	const history = useHistory();

	const redirect = async () => {
		history.push(notification.url);
	};

	return (
		<Notification
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={NotificationIcon}
			Primary={<div>{htmlFormatter(notification.message)}</div>}
			Secondary={null}
			disabledActionsList={["stopSubscribe"]}
		/>
	);
}
